<template>
    <!-- note: explicit null check is intentional 
     false is a valid result, null is the absence of one -->
    <DsBadge
        v-if="isInsured !== null"
        :icon="isInsured ? 'fa-solid fa-shield-check' : 'fa-solid fa-shield-exclamation'"
        :text="isInsured ? 'Insured' : 'Not insured'"
        :variant="isInsured ? 'active' : 'error'"
    />
</template>

<script setup lang="ts">
import DsBadge from '@/components/design-system/badge/DsBadge.vue';
import type { PayoffInsuredStatus } from '@/interfaces/payoff/payoff-order.types';

defineProps<{
    isInsured: PayoffInsuredStatus;
}>();
</script>
